import { cn } from "@/lib/utils";
import ratelMark from "@/assets/taskratel-mark.png";

type BrandSize = "sm" | "md" | "lg";

const boxSize: Record<BrandSize, string> = {
  sm: "h-9 w-9",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

const wordmarkSize: Record<BrandSize, string> = {
  sm: "text-lg",
  md: "text-xl",
  lg: "text-2xl",
};

export function BrandIcon({
  size = "md",
  className,
  iconClassName,
}: {
  size?: BrandSize;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <img
      src={ratelMark}
      alt="TaskRatel honey badger logo"
      width={512}
      height={512}
      className={cn(
        "rounded-lg object-contain",
        boxSize[size],
        className,
        iconClassName
      )}
    />
  );
}

export function BrandMark({
  size = "md",
  className,
  wordmarkClassName,
  iconClassName,
}: {
  size?: BrandSize;
  className?: string;
  wordmarkClassName?: string;
  iconClassName?: string;
}) {
  return (
    <div className={cn("inline-flex items-center gap-2", className)}>
      <BrandIcon size={size} iconClassName={iconClassName} />
      <span className={cn("font-display font-bold", wordmarkSize[size], wordmarkClassName)}>
        Task<span className="text-primary">Ratel</span>
      </span>
    </div>
  );
}
